import {
  THREAT_HUNTING_RECORDS_SET,
  THREAT_HUNTING_REQ,
  THREAT_HUNTING_SUCCESS,
  THREAT_HUNTING_ERROR,
  THREAT_HUNTING_RESET_STATUS
} from './query-fields.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import Base from '@/resources/Base'
import {
  querySearchMetaInfo,
  searchNetworkColumn,
  searchUserColumn
} from '@/column-header/query_search/query-search-meta'

const state = {
  threatHuntingQuerySearchReqStatus: '',
  threatHuntingQuerySearchResult: { columns: [], data: {} }
}

const getters = {
  threatHuntingQuerySearchReqStatus: state => state.threatHuntingQuerySearchReqStatus,
  threatHuntingQuerySearchResult: state => state.threatHuntingQuerySearchResult
}

const mutations = {
  [THREAT_HUNTING_RECORDS_SET]: (state, { columns, data } = {}) => {
    state.threatHuntingQuerySearchResult = {
      columns: columns,
      data: data
    }
  },
  [THREAT_HUNTING_REQ]: state => {
    state.threatHuntingQuerySearchReqStatus = 'loading'
  },
  [THREAT_HUNTING_SUCCESS]: state => {
    state.threatHuntingQuerySearchReqStatus = 'saved'
  },
  [THREAT_HUNTING_ERROR]: state => {
    state.threatHuntingQuerySearchReqStatus = 'error'
  },
  [THREAT_HUNTING_RESET_STATUS]: state => {
    state.threatHuntingQuerySearchReqStatus = ''
  }
}

const actions = {
  [THREAT_HUNTING_REQ] (context, { dateRange, eventType, queryCriteria } = {}) {
    let queryFilters = _.cloneDeep(queryCriteria)
    let eventTypeFilter = _.cloneDeep(eventType)

    if (!_.isArray(eventTypeFilter.values)) {
      eventTypeFilter.values = [eventTypeFilter.values]
    }

    let queryPostBody = { event_type: eventTypeFilter, query: queryFilters }

    // check for user custom time selection
    if (_.has(dateRange, 'startTime') || _.has(dateRange, 'endTime')) {
      try {
        queryPostBody.start_time = dateRange.startTime.toISOString()
        queryPostBody.end_time = dateRange.endTime.toISOString()
      } catch (error) {
        queryPostBody.start_time = dateRange.startTime
        queryPostBody.end_time = dateRange.endTime
      }
    } else {
      queryPostBody.date_range = dateRange.value
    }

    return new Promise((resolve, reject) => {
      context.commit(THREAT_HUNTING_REQ)
      ApiRest()
        .post('/bi/searchquery', queryPostBody)
        .then(({ data }) => {
          function appendEventClass (eventType) {
            let eventClasses = context.rootState.threatHuntingQuerySearchFields.threatHuntingEventTypes
            for (let eventClass of eventClasses) {
              let eventName = _.find(eventClass.values, { value: eventType })
              if (!_.isUndefined(eventName)) {
                return eventClass.value
              }
            }
            return eventType
          }
          function appendEventType (eventType) {
            let eventTypes = _.map(context.rootState.threatHuntingQuerySearchFields.threatHuntingEventTypes, 'values')
            eventTypes = _.flatten(eventTypes)
            let eventValue = _.find(eventTypes, { value: eventType })
            if (!_.isUndefined(eventValue)) {
              return eventValue.label
            }
            return eventType
          }
          let searchResultColumns = _.cloneDeep(querySearchMetaInfo.meta.columns)
          // if (
          //   _.intersection(
          //     ['user', 'AuditSuccessfulLogon', 'AuditFailedLogon', 'RDPLogon', 'AuditUserCreate', '1100'],
          //     eventType.values
          //   ).length > 0
          // ) {
          //   searchResultColumns.push(searchUserColumn)
          // }
          // if (
          //   _.intersection(
          //     [
          //       'network',
          //       'TcpAcceptListenerComplete',
          //       'TcpConnectTcpComplete',
          //       'DNSQueryResponse',
          //       'PowershellConnectComplete',
          //       'connect',
          //       'connects',
          //       'accept',
          //       'accept4',
          //       'socket'
          //     ],
          //     eventType.values
          //   ).length > 0
          // ) {
          //   searchResultColumns.push(searchNetworkColumn)
          // }

          // let agentList = context.rootState.agents.agentList.models
          let agentList = []
          if (!_.isUndefined(context.rootState.agents.agentList.models)) {
            agentList = context.rootState.agents.agentList.models
          }
          data = _.map(data, queryResult => {
            let host = _.find(agentList, { agentNumber: queryResult.agentId })
            if (_.indexOf(['DELETES', 'MODIFIES', 'CREATES', 'USES'], queryResult.edgeType) > -1) {
              queryResult.edgeClass = appendEventClass(queryResult.edgeType)
              queryResult.edgeName = appendEventType(queryResult.edgeType)
            } else {
              queryResult.edgeClass = appendEventClass(queryResult.edgeName)
              queryResult.edgeName = appendEventType(queryResult.edgeName)
            }
            if (queryResult.sourcePid === -1) {
              queryResult.sourcePid = ''
            }
            if (queryResult.sourcePpid === -1) {
              queryResult.sourcePpid = ''
            }
            if (queryResult.sourcePort === -1) {
              queryResult.sourcePort = ''
            }
            if (queryResult.destPort === -1) {
              queryResult.destPort = ''
            }
            return new Base(
              'timestampMillis',
              _.extend(queryResult, {
                agentNumber: queryResult.agentId,
                agentId: (host) ? host.agentId : '',
                hostname: (host) ? host.customHostname : ''
              })
            )
          })
          data = new IQCollection(data, {}, { csvName: 'IQ-Threat-Hunting' })
          // // set csv columns for content download
          let dataAttributes = []
          for (let col in searchResultColumns) {
            for (let attr of searchResultColumns[col].columns) {
              dataAttributes.push(attr.name)
            }
          }
          data.csvConfig.columns = _.flatten(dataAttributes)
          context.commit(THREAT_HUNTING_RECORDS_SET, { columns: searchResultColumns, data: data })
          resolve({ columns: searchResultColumns, data: data })
        })
        .catch(errMsg => {
          context.commit(THREAT_HUNTING_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [THREAT_HUNTING_SUCCESS] (context) {
    context.commit(THREAT_HUNTING_SUCCESS)
  },
  [THREAT_HUNTING_RESET_STATUS] (context) {
    context.commit(THREAT_HUNTING_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/threat_hunting/query-search.module.js